module.exports = __webpack_public_path__ + "img/antes_despues_112.4a22c706.png";